import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const UserRolesPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Users}
        fetchRecordsUrl={AdminReqUrls.admin__users__mainPage_fetch_recordList}
    />)
});
export default UserRolesPage;
